import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconApps, IconMoreSliders } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { showOverflowDrawer } from '../../functions.web';
/**
 * Implementation of a button for toggling the overflow menu.
 */
class OverflowToggleButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.moreActions';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeMoreActions';
    icon = IconApps;
    label = 'toolbar.moreActions';
    toggledLabel = 'toolbar.moreActions';
    tooltip = 'toolbar.moreActions';
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props.isOpen;
    }
    /**
     * Indicates whether a key was pressed.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _onKeyDown() {
        this.props.onKeyDown();
    }
    /**
     * 手机抽屉用滑条「更多」图标；电脑宽屏仍用九宫格「应用」。
     *
     * @override
     * @protected
     * @returns {Function}
     */
    _getIcon() {
        return this.props._isOverflowDrawer ? IconMoreSliders : super._getIcon();
    }
    /**
     * 手机抽屉文案为「更多」；电脑宽屏保持「应用」。
     *
     * @override
     * @protected
     * @returns {string}
     */
    _getLabel() {
        return this.props._isOverflowDrawer ? 'toolbar.moreMenu' : super._getLabel();
    }
    /**
     * 与可见文案保持一致。
     *
     * @override
     * @protected
     * @returns {string}
     */
    _getTooltip() {
        return this.props._isOverflowDrawer ? 'toolbar.moreMenu' : super._getTooltip();
    }
    /**
     * 无障碍文案与可见标签对齐。
     *
     * @override
     * @protected
     * @returns {string}
     */
    _getAccessibilityLabel() {
        if (this.props._isOverflowDrawer) {
            return this._isToggled()
                ? 'toolbar.accessibilityLabel.closeMoreActions'
                : 'toolbar.moreMenu';
        }
        return super._getAccessibilityLabel();
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        _isOverflowDrawer: showOverflowDrawer(state)
    };
}
export default connect(mapStateToProps)(translate(OverflowToggleButton));
